import React, { useState, useRef } from "react";
import { Row, Col, Modal, Form, Button, Container } from "react-bootstrap";
import { Button as AntBtn, Button as AntButton, Card, Modal as AntModal, Row as AntRow, Spin, Space } from "antd";
import Title from "antd/es/typography/Title";
import { Input } from "antd";
import { SearchOutlined,  LockOutlined } from "@ant-design/icons";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import { useNavigate, useLocation , useParams  } from "react-router-dom";
// import { getGroupOrderID } from "../../Helpers/apiCalls/OrderApi";
import toast from "react-hot-toast";
import "./AllTables.css";
import {
  getRestoLogin,
  getRole,
  refreshPage,
  toastStyle,
} from "../../Helpers/Utils/Common";
//images
import CommonPrint from "../../Components/Print/CommonPrintReceipt";
import {
  cancelSalesInvoice,
  // getAllPaymentSearch,
  markOR,
  printBase64,
} from "../../Helpers/apiCalls/paymentAPI";
import { ToastContainer } from "react-toastify";
import imageCompression from "compressorjs";
import passwordIcon from "../../Assets/Images/password.png";
import usernameIcon from "../../Assets/Images/username.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { loginAuthorize } from "../../Helpers/apiCalls/authApi";
import html2canvas from "html2canvas";
import { SyncLoader } from "react-spinners";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import { printAsTextFile } from "../../Helpers/apiCalls/paymentAPI";
import { Select } from "antd";
import { UserOutlined } from "@ant-design/icons";


function AllTables() {
  const state = useLocation();
  const role = getRole();
  const [modal, contextModal] = AntModal.useModal();
  const restoType = getRestoLogin();
  const [inactive, setInactive] = useState(true);
  const [orderID, setOrderID] = useState();
  const [text, setText] = useState(["", "", "", ""]);
  const [closeTable, setCloseTables] = useState([]);
  const [auhtenticateBy, setAuhtenticateBy] = useState({});
  const [printingInProgress, setPrintingInProgress] = useState(false);
  const { terminal } = useParams();

  const [selectedOR, setSelectedOR] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();
  const [openAuthorizeModal, setOpenAuthorizeModal] = useState(false);
  const [openModalOrderSummary, setOpenModalOrderSummary] = useState(false);
  const [discountDetails, setDiscountDetails] = useState([]);
  const [openDiscountModal, setOpenDiscountModal] = useState(false);
  const [percentage, setPercentage] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);
  const [hasAuthenticationHistory, setHasAuthenticationHistory] = useState(false);
  const [orders, setOrders] = useState({});
  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
  });

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [disableClick, setDisableClick] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [doneModal, setDoneModal] = useState(false);
  const [paymentBreakdown, setPaymentBreakdown] = useState([]);
  const [foodServer, setFoodServer] = useState("");
  const [userOptions, setUserOptions] = useState([]);
  const [currentAction, setCurrentAction] = useState("");

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const [orNo, setOrNo] = useState("");
  const componentRefSummaryInvoice = useRef();
  const [forNonVat, setForNonVat] = useState([]);

  async function fetchPayments() {
    setShowLoader(true);
    // const response = await getAllPaymentSearch(
    //   filter.date_from,
    //   filter.date_to,
    //   orNo
    // );
    const payload = {
      date_from: filter.date_from,
      date_to: filter.date_to,
      or_no: orNo,
    };
    const response = await UseGetRequest(
      "payments/getAll",
      payload,
      getRestoLogin()
    );
    if (response.data) {
      setCloseTables(response.data.data.data.payments);
    } else {
      setCloseTables([]);
      setTimeout(() => setShowLoader(false), 2000);
    }
    setTimeout(() => setShowLoader(false), 2000);
  }

  React.useEffect(() => {
    fetchPayments();
  }, [filter, orNo]);

  React.useEffect(() => {
  async function fetchAllUsers() {
    const response = await UseGetRequest("users/search", {}, getRestoLogin());
    if (response.data) {
      const res = response.data.map((row) => {
        return {
          value: row.username,
          label: row.username,
        };
      });
      setUserOptions(res);
    } else {
      setUserOptions([]);
    }
  }

  fetchAllUsers();
  fetchPayments();
}, [filter, orNo]);


  async function fetchOrderInfo(id) {
    setOpenModalOrderSummary(true);
    // const response = await getGroupOrderID(id);
    const response = await UseGetRequest(
      "orders/show/" + id,
      {for_printing: "1"},
      getRestoLogin()
    );
    if (response.data) {
      setOrderDetails(response.data.message.order_details);
      setForNonVat(response.data.message.discounts_details);
      setPaymentInfo(response.data.message.payment);
      setPaymentBreakdown(response.data.message.payment_details);
      setOrders(response.data.message.order);
      setFoodServer(response.data.message.order.food_server);
      var arr = response.data.message.discounts_details.map((data) => {
        return data.percentage;
      });
      setPercentage(arr);
      // const res = response.data.message.discounts_details?.map((row) => {
      //   return {...row,
      //     discount_id: row.discount_id,
      //     name: row.customer_name,
      //     id: row.customer_id,
      //     discount_name: row.discount_type,
      //   };
      // });
      // setDiscountDetails(res);

    }
  }

  //Login Authorize for Discount
  async function handleLoginAuthentication() {
    const response = await loginAuthorize(
      username,
      password,
      terminal,
      restoType
    );
    if (response.data) {
      setUsername("");
      setPassword("");
      setOpenAuthorizeModal(false);
      setOpenDiscountModal(true);
      setHasAuthenticationHistory(true);
      toast.success("Successful Login!", { style: toastStyle() });
    } else {
      setHasAuthenticationHistory(false);
      toast.error(response.error.data.messages.error, {
        style: toastStyle(),
      });
    }
  }

  async function fetchOrderDiscounts(orderID) {
    const response = await UseGetRequest(
      "order_discounts/show/" + orderID,
      {},
      getRestoLogin()
    );
    if (response.data) {
      const res = response.data.order_discount_detail?.map((row) => {
        return {...row,
          discount_id: row.discount_id,
          name: row.customer_name,
          id: row.customer_id,
          discount_name: row.discount_type,
        };
      });
      setDiscountDetails(res);
    }
  }

  async function printOR(data) {
  if (getRole() === "3") {
    // Cashier needs authentication
    setSelectedOR(data);
    setCurrentAction("reprint");
    setOpenAuthorizeModal(true);
  } else {
    // Admin can proceed directly
    fetchOrderInfo(data.order_id);
    fetchOrderDiscounts(data.order_id);
    setSelectedOR(data);
  }
}
  async function printNewOR() {
    setAllowPrint(true);
    const response = await markOR(
      selectedOR.order_id,
      "reprint",
      getRestoLogin()
    );
    handlePrint();
    if (response.data) {
      toast.success("Marked OR reprint", {
        style: toastStyle(),
      });
    } else {
      setOpenModalOrderSummary(false);
      setAllowPrint(false);
    }
  }

 async function submit() {
  setDisableClick(true);
  const response = await loginAuthorize(
    username,
    password,
    "",
    getRestoLogin()
  );
  if (response.data) {
    setAuhtenticateBy(response.data.id);
    setOpenAuthorizeModal(false);
    setUsername("");
    setPassword("");
    
    // Execute the appropriate action after authentication
    if (currentAction === "cancel") {
      setDoneModal(true);
    } else if (currentAction === "reprint") {
      fetchOrderInfo(selectedOR.order_id);
      fetchOrderDiscounts(selectedOR.order_id);
    }
    
    toast.success("Successful Login!", { style: toastStyle() });
    setDisableClick(false);
  } else {
    toast.error(response.error.data.messages.error, {
      style: toastStyle(),
    });
    setDisableClick(false);
  }
}

  async function cancelSI() {
    const responses = await cancelSalesInvoice(
      auhtenticateBy,
      orderID,
      getRestoLogin()
    );
    if (responses.data) {
      toast.success("SI Cancelled SUccessfully!");
      refreshPage();
    }
  }

  const handleCancel = (data) => {
  setOrderID(data.id);
  setCurrentAction("cancel");
  if (getRole() === "1" || getRole() === "2" || getRole() === "4") {
    setDoneModal(true);
  } else {
    setOpenAuthorizeModal(true);
  }
};

  const handleFilter = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filter };
    filtercopy[name] = value;
    setFilter(filtercopy);
  };

  const divId = useRef(null); // Initialize useRef with null
  const [allowPrint, setAllowPrint] = useState(false);

  const handlePrint = () => {
    // setIsClicked(true)
    if (divId.current) {
      const element = divId.current;

      html2canvas(element, { scale: 1 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        // const newWindow = window.open();
        // if (newWindow) {
        //   // Write the image to the new window
        //   newWindow.document.write(`<img src="${imgData}" alt="Captured Image"/>`);
        //   newWindow.document.close();
        // }
        // printBase64Data(imgData);
        const blob = new Blob([imgData], { type: "text/plain" });
        const txtFile = new File([blob], "data.txt", { type: "text/plain" });
        handlePrintTextFile(txtFile)
      });
    }
  };

  // async function printBase64Data(image) {
  //   const response = await printBase64(
  //     window.printer_name,
  //     image,
  //     "0",
  //     getRestoLogin(),
  //     "All Tables"
  //   );
  //   if (response.data) {
  //     setAllowPrint(false);
  //     setAllowPrint(false);
  //     if (getRole() === "1" || getRole() === "7") {
  //       refreshPage();
  //     } else {
  //       navigate("/orderingpage/");
  //     }
  //     refreshPage();
  //   } else {
  //     // setIsClicked(false)
  //   }
  // }

  async function handlePrintTextFile(txtFile) {
    setPrintingInProgress(true)
    const response = await printAsTextFile(
      window.printer_name,
      txtFile,
      "0",
      getRestoLogin()
    );
    if (response.data) {
      setAllowPrint(false);
      setAllowPrint(false);
      if (getRole() === "1" || getRole() === "2" || getRole() === "4") {
        refreshPage();
      } else {
        navigate("/orderingpage/");
      }
      refreshPage();
    } else {
      setPrintingInProgress(false)
      // setIsClicked(false)
    }
  }

  return (
    <div>
      <ToastContainer />
      {state.state === null && (
        <NavbarAdmin
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"Closed Invoices"} //Dashboard navbar index
          page={"Closed Invoices"}
        />
      )}
      <div
        className={`container full-height ${
          inactive ? "inactive" : "active"
        }`}
      >
        <Row>
          <Col xl={6} lg={6} md={6} sm={6} xs={6}>
            <h1 className="page-title-menu">CLOSED INVOICES </h1>
          </Col>
          {state.state === null ? (
            <Col
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={6}
              className="d-flex justify-content-end"
            >
              <Input
                style={{ width: 250 }}
                suffix={<SearchOutlined />}
                placeholder="Search invoice no."
                className="h-60"
                onKeyDown={(e) =>
                  e.key === ("Enter" || "NumpadEnter") &&
                  setOrNo(e.target.value)
                }
                onChange={(e) => setOrNo(e.target.value)}
              />
            </Col>
          ) : (
            <>
              <Col
                xl={5}
                lg={5}
                md={5}
                sm={5}
                xs={5}
                className="d-flex justify-content-end"
              >
                <Input
                  style={{ width: 250 }}
                  suffix={<SearchOutlined />}
                  placeholder="Search invoice no."
                  className="h-60"
                  onKeyDown={(e) =>
                    e.key === ("Enter" || "NumpadEnter") &&
                    setOrNo(e.target.value)
                  }
                  onChange={(e) => setOrNo(e.target.value)}
                />
              </Col>
              <Col
                xl={1}
                lg={1}
                md={1}
                sm={1}
                xs={1}
                className="d-flex justify-content-end"
              >
                <Row>
                  <Col>
                    <button
                      size="sm"
                      className="invoice-back-btn"
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </button>
                  </Col>
                </Row>
              </Col>
            </>
          )}
          <hr />
        </Row>
        <Row className="mb-3">
          <Col className="d-flex justify-content-left">
            <Row>
              {/* <Col className=" d-flex align-items-center">
                <span>FILTER BY DATE:</span>
              </Col> */}
              <Col>
                <div className="PO-filters d-flex align-items-center">
                  <span className="me-4">FROM:</span>
                  <Form.Control
                    size="md"
                    type="date"
                    name="date_from"
                    className="date-filter me-3"
                    onChange={handleFilter}
                    value={filter.date_from}
                  />
                  <span className="me-4">TO:</span>
                  <Form.Control
                    size="sm"
                    type="date"
                    name="date_to"
                    className="date-filter me-3"
                    onChange={handleFilter}
                    value={filter.date_to}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          {closeTable.length > 0 ? (
            // <Row className="all-table-container">
            //   <Col xs={12} lg={4} className="my-1 mb-3">
            <Row className="all-table-container">
              {closeTable.map((data) => {
                return (
                  <Col
                    xs={6}
                    md={4}
                    lg={3}
                    className="close-invoice-cards mt-1"
                  >
                    <Card title={`SI # ${data.id}`}>
                      <Row className="d-flex justify-content-between">
                        {data.is_deleted !== "1" ? (
                          <Col xs={6} className="">
                            <AntBtn
                              className="redo-cancel-button w-100"
                              onClick={() => handleCancel(data)}
                              disabled={getRole () === "3"}
                            >
                              Cancel
                            </AntBtn>
                          </Col>
                        ) : (
                          <Col>
                            <AntBtn
                              className="redo-cancel-button w-100"
                              disabled
                            >
                              Cancelled
                            </AntBtn>
                          </Col>
                        )}
                        {(data.is_deleted === "1" && data.is_printed === "1") ||
                        (data.is_deleted === "0" && data.is_printed === "0") ? (
                          <Col xs={6} className="d-flex justify-content-end">
                            <AntBtn
                              type="primary"
                              className="redo-print-button w-100"
                              onClick={() => printOR(data)}
                            >
                              Reprint
                            </AntBtn>
                          </Col>
                        ) : (
                          <Col>
                            <AntBtn
                              type="primary"
                              className="redo-print-button"
                              onClick={() => printOR(data)}
                            >
                              Print
                            </AntBtn>
                          </Col>
                        )}
                      </Row>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          ) : (
            //   </Col>
            // </Row>
            <Row className=" all-table-container">
              {showLoader ? (
                <Col className="p-5 d-flex justify-content-center center">
                  <SyncLoader color="var(--tertiary-color)" size={20} />
                </Col>
              ) : (
                <Col className="p-5 d-flex justify-content-center center">
                  <div className="redo-no-data-conts">
                    {/* <img src={NoDataImg} alt="no data found" className="redo-no-data-cont"/> */}
                    <span className="text-center"> No data found.</span>
                  </div>
                </Col>
              )}
            </Row>
          )}
        </Row>
        <div>
          <label className="powered-label pt-2 mt-2 text-center">
            Powered by MYT SofDev Solutions Inc. EPSOS 1.0.0
          </label>
        </div>
      </div>

      <div ref={divId} className="hide-from-screen">
          <div className="d-flex justify-content-center">
            <CommonPrint
              isReprint
              type="officialReceipt"
              discounts={discountDetails}
              orderItems={orderDetails}
              orderInfo={orders}
              paymentDetails={paymentInfo}
              paymentBreakdown={paymentBreakdown}
              computedDiscount={{total_discount: selectedOR.discount, total_vat_exempt: selectedOR.vat_exemption}}
              serviceCharge={selectedOR.service_charge}
              superGrandTotal={selectedOR.total_amount}
              foodServer={foodServer}
            />
          </div>
        </div>

      {/* Authenticate login to discount */}

<AntModal
  open={openAuthorizeModal}
  onCancel={() => {
    setOpenAuthorizeModal(false);
    setUsername("");
    setPassword("");
    setCurrentAction("");
  }}
  footer={null}
  title="AUTHENTICATE"
>
  <AntRow className="mt-3">
    <div className="custom-select-container w-100">
      <UserOutlined className="custom-select-icon black" />
      <Select
        suffixIcon={null}
        placeholder="Username"
        options={userOptions}
        showSearch
        filterOption={(input, option) =>
          option.label?.toLowerCase().includes(input?.toLowerCase())
        }
        onChange={(e) => setUsername(e)}
        value={username}
        style={{ width: '100%' }}
      />
    </div>
  </AntRow>
  <AntRow className="mt-2">
    <Input.Password
      className="bigger-input-field"
      prefix={<LockOutlined className="site-form-item-icon" />}
      type="password"
      placeholder="Password"
      onChange={(e) => setPassword(e.target.value)}
      onKeyPress={(e) =>
        e.key === ("Enter" || "NumpadEnter") && submit()
      }
      value={password}
      style={{ width: '100%' }}
    />
  </AntRow>
  <AntRow className="mt-3 d-flex justify-content-end">
    <Space>
      <AntButton
        className="me-2 px-4"
        onClick={() => {
          setOpenAuthorizeModal(false);
          setUsername("");
          setPassword("");
          setCurrentAction("");
        }}
      >
        Cancel
      </AntButton>
      <AntButton
        type="primary"
        className="px-4"
        onClick={submit}
        disabled={username === "" || password === "" || disableClick}
        loading={disableClick}
      >
        Submit
      </AntButton>
    </Space>
  </AntRow>
</AntModal>


      <Modal
        size="md"
        show={doneModal}
        onHide={() => setDoneModal(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          className="bold-font"
          title="Cancel Invoice"
        ></Modal.Header>
        <Modal.Body className="bold-font">
          <text className="custom-modal-body-title"> Cancel SI </text>
          <Row>
            <Col xs={12} className="p-3 d-flex justify-content-center">
              <h6 style={{ color: "var(--title-color)" }}>
                <strong>
                  Are you sure you want to cancel "Invoice # {orderID} " ?
                </strong>
              </h6>
            </Col>
          </Row>
          <Row className="d-flex justify-content-end">
            <Col></Col>
            <Col className="d-flex justify-content-end">
              <Button
                size={"xs"}
                className="cancel-btn"
                onClick={() => setDoneModal(false)}
              >
                Back
              </Button>
            </Col>
            <Col className="d-flex justify-content-end">
              <Button
                size={"xs"}
                className="save-btn"
                onClick={() => cancelSI()}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      
      <Modal
        size="md"
        show={openModalOrderSummary}
        onHide={() => setOpenModalOrderSummary(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className="bold-font">
          <h4>ORDER SUMMARY</h4>
          <hr />
          <Container>
            <Row>
              <Col>
                <h5>ITEM/S</h5>
              </Col>
              <Col className="d-flex justify-content-end">
                <h5>QTY</h5>
              </Col>
            </Row>
            <Row>
              <Col>
                {orderDetails.map((data) => {
                  return (
                    <Row>
                      <Col>
                        <label>{data.menu_name}</label>
                      </Col>
                      <Col className="d-flex justify-content-end">
                        <label>{data.qty}</label>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            </Row>
            <Row className="pt-5">
              <Col xl={4}></Col>
              <Col className="d-flex justify-content-end">
                <Button
                  className="cancel-btn"
                  onClick={() => setOpenModalOrderSummary(false)}
                >
                  CANCEL
                </Button>
              </Col>
              <Col className="">
                <Button className="save-btn w-100" onClick={printNewOR}>
                  REPRINT
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>

{/* LOADER MODAL */}
      <AntModal
        maskClosable={false}
        open={printingInProgress}
        footer={null}
        closeIcon={false}
      >
        <AntRow className="d-flex justify-content-center">
          <Title level={5}>PRINTING IN PROGRESS</Title>
        </AntRow>
        <Row className="d-flex justify-content-center mt-3">
          <Spin size="large"/>
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          Please do not close this window.
        </Row>
      </AntModal>
    </div>
  );
}

export default AllTables;
